import { render, staticRenderFns } from "./MousePosition.vue?vue&type=template&id=dd159c78"
import script from "./MousePosition.vue?vue&type=script&lang=js"
export * from "./MousePosition.vue?vue&type=script&lang=js"
import style0 from "./MousePosition.vue?vue&type=style&index=0&id=dd159c78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports